import React from 'react';
import PropType from 'prop-types';
import Tag from 'sushiweb/Tag';
import blue from 'sushiweb/tokens/color/blue';
import grey from 'sushiweb/tokens/color/grey';
import styled from 'styled-components';

const TagContainer = styled.div`
  // card header is a flex box
  flex-grow: 1;

  display: flex;
  justify-content: space-evenly;
  gap: 2rem;
  padding: 2rem;
  flex-wrap: wrap;
`;

const StyledTag = Tag;

StyledTag.Wrapper = styled(StyledTag.Wrapper)`
  font-size: 1.4rem;
  padding: 0.4rem 0;
  flex-grow: 1;
`;

const StepHeader = ({ steps, currentStep }) => {
  const getBgColor = index => {
    if (currentStep === Number(index)) return blue.z200;

    return grey.z200;
  };

  const getFontColor = index => {
    if (currentStep === Number(index)) return grey.z900;

    return grey.z500;
  };

  return (
    <TagContainer>
      {Object.keys(steps).map(key => {
        const stepName = steps[key];
        return (
          <StyledTag
            key={stepName}
            bgColor={() => getBgColor(key)}
            textColor={() => getFontColor(key)}
            label={`${stepName}`}
          />
        );
      })}
    </TagContainer>
  );
};

StepHeader.propTypes = {
  steps: PropType.objectOf(PropType.any),
  currentStep: PropType.number,
};

StepHeader.defaultProps = {
  steps: {},
  currentStep: 0,
};

export default StepHeader;
